import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import CursorEffect from './components/CursorEffect';
import ScrollProgress from './components/ScrollProgress';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import StatsTicker from './components/StatsTicker';
import HowItWorks from './components/HowItWorks';
import TechnologySection from './components/TechnologySection';
import MarketSection from './components/MarketSection';
import SecuritySection from './components/SecuritySection';
import TeamSection from './components/TeamSection';
import RaiseSection from './components/RaiseSection';
import RoadmapSection from './components/RoadmapSection';
import CTAFooter from './components/CTAFooter';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import Disclaimer from './pages/Disclaimer';

function removePlatformBadge() {
  document.querySelectorAll('a, div, span').forEach((el) => {
    const text = el.textContent || '';
    const href = el.getAttribute('href') || '';
    if (
      (text.toLowerCase().includes('made with emergent') ||
        href.includes('emergent.sh') ||
        href.includes('emergentagent.com')) &&
      el.children.length <= 3
    ) {
      el.style.cssText += 'display:none!important;visibility:hidden!important;opacity:0!important;';
    }
  });
}

function MainSite() {
  useEffect(() => {
    removePlatformBadge();
    const observer = new MutationObserver(() => removePlatformBadge());
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="App" style={{ background: '#000', overflowX: 'hidden' }}>
      <ScrollProgress />
      <Navbar />
      <main>
        <HeroSection />
        <StatsTicker />
        <HowItWorks />
        <TechnologySection />
        <MarketSection />
        <SecuritySection />


        <RoadmapSection />
        <CTAFooter />
      </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <CursorEffect />
      <Routes>
        <Route path="/" element={<MainSite />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
